import React from 'react';
import styled from 'styled-components';

import { devices } from '@/styles/breakpoints';
export const BlogLayout = ({ children }) => {
  return <Wrapper>{children}</Wrapper>;
};

const Wrapper = styled.div`
  background-color: #f6f7f9;
  padding: 40px 0px;
  @media only screen and ${devices.desktop} {
    padding: 80px 0;
  }
`;
